// Vue 3 polyfill for jwt-ui compatibility
// 重新导出 Vue 的所有内容并添加缺失的函数

export * from 'vue'

// isFunction polyfill - jwt-ui 需要，但 Vue 3 不直接导出
export const isFunction = (val) => typeof val === 'function'

// isEmpty polyfill
export const isEmpty = (val) => {
  if (val == null) return true
  if (typeof val === 'string') return val.length === 0
  if (Array.isArray(val)) return val.length === 0
  if (typeof val === 'object') return Object.keys(val).length === 0
  return false
}
